export const SERVER_ERROR_KEY = "server_error";
export const UNAUTHORIZED_ERROR_KEY = "unauthorized_error";
export const CLIENT_APP_ERROR_KEY = "client_app_error";

export const USERNAME_EXISTS_ERROR_KEY = "username_exists_error";
export const USERNAME_NOT_FOUND_ERROR_KEY = "username_not_found_error";

export const VALIDATION_ERROR_KEY = "validation_error";

export const EMAIL_CONFIRMATION_ERROR = "UserLambdaValidationException";

export const REFERRAL_CODE_INVALID_ERROR_KEY = "referral_code_invalid_error";